<template>
	<div>
		<footer>
			<div class="row">
				<div class="columns column3">
					<div class="footer-logo" />
				</div>
				<div class="columns column3">
					<h3>{{ defaults[locale].website.footerNavigate }}</h3>
					<p>
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }} <br />
						</nuxt-link>
						<a href="#" @click.prevent="openConsent">{{ $t('consentOpen') }}</a>
					</p>
				</div>
				<div class="columns column3">
					<h3>Socials</h3>
					<social-media :socials="socials" />
				</div>
				<div v-if="page" class="columns column3">
					<h3>Language</h3>
					<lang-select :items="page.langmenu" />
				</div>

				<div class="columns column3">
					<h3>{{ defaults[locale].website.footerContact }}</h3>
					<p>
						{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}<br />
						{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}<br />
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<span>{{ defaults[locale].website.phone }}</span> </a
						><br />
						<a :href="`mailto:${defaults[locale].website.email}`">
							<span>{{ defaults[locale].website.email }}</span>
						</a>
					</p>
				</div>
			</div>
		</footer>

		<section class="partner-logos">
			<div class="row align-center">
				<div class="columns column12">
					<a href="https://theaficionados.com/" target="_blank">
						<picture>
							<source srcset="~/assets/images/partners/logo-the-afficionados.webp" type="image/webp" />
							<source srcset="~/assets/images/partners/logo-the-afficionados.png" />
							<img
								src="~/assets/images/partners/logo-the-afficionados.png"
								alt="The Aficionados"
								style="max-width: 220px"
								loading="lazy"
								class="partner-logo"
							/>
						</picture>
					</a>
					<a href="https://www.mrandmrssmith.com/" target="_blank">
						<picture>
							<source srcset="~/assets/images/partners/logo-mr-mrs-smith-white.png" />
							<img
								src="~/assets/images/partners/logo-mr-mrs-smith-white.png"
								alt="Mr & Mrs smith"
								style="max-width: 165px"
								loading="lazy"
								class="partner-logo"
							/>
						</picture>
					</a>
					<a href="https://www.tablethotels.com/" target="_blank">
						<picture>
							<source srcset="~/assets/images/partners/logo-tablet-hotels.webp" type="image/webp" />
							<source srcset="~/assets/images/partners/logo-tablet-hotels.png" />
							<img
								src="~/assets/images/partners/logo-tablet-hotels.png"
								alt="Tablet Hotels"
								style="max-width: 200px"
								loading="lazy"
								class="partner-logo"
							/>
						</picture>
					</a>
					<a
						href="https://guide.michelin.com/nl/nl/hotels-stays/amsterdam/de-durgerdam-13133?arr=2026-11-03&dep=2026-11-04&nA=1&nC=0&nR=1"
						target="_blank"
					>
						<picture>
							<source srcset="~/assets/images/partners/logo-michelin-guide-red.png" />
							<img
								src="~/assets/images/partners/logo-michelin-guide-red.png"
								alt="MICHELIN Key"
								style="max-width: 110px"
								loading="lazy"
								class="partner-logo"
							/>
						</picture>
					</a>
				</div>
			</div>
		</section>

		<footer class="bottom-footer">
			<div class="row">
				<div class="columns column12 align-center">
					<a href="https://www.aedes.co/en/" target="_blank">
						<img src="~/assets/images/logo-aedes-white.png" alt="An Aedes Place" loading="lazy" />
					</a>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, socials, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const { openConsent } = useCookieConsent();

await fetchPage();
await fetchDefaults();

const { data: footermenu } = await useWebsiteFetch('footermenu');
</script>

<style lang="scss" scoped>
.partner-logos {
	padding: 10px 0;
	background: $footer-background-color;

	a {
		margin: 10px 25px 25px;
		display: inline-block;
	}
}

footer {
	background: $footer-background-color;
	color: $footer-link-color;
	padding: 75px 0 50px;
	font-size: 16px;
	margin-top: 0;

	p {
		line-height: 30px;
		font-family: 'courier_newregular', MessinaSerif, serif;
	}

	h3 {
		color: #fff;
		margin: 0 0 25px;
	}

	.row {
		display: flex;
		flex-flow: row nowrap;

		.columns {
			width: 25%;
		}
	}

	&.bottom-footer {
		background: #000;
		color: #f7f5eb;
		display: flex;
		padding: 25px 0;
		margin: 0;

		.row {
			flex-flow: row nowrap;
			justify-content: space-between;
			align-items: center;

			.columns {
				width: 100%;
			}
		}

		p {
			margin: 0;
		}

		a {
			font-weight: 700;
		}

		img {
			width: 135px;
		}
	}

	.button {
		color: #fff;
		background: $primary-color;

		&:hover {
			color: #fff;
			background: $primary-color-hover;
		}
	}
}

.footer-logo {
	background: url('~/assets/images/logo-dedurgerdam-white-medium.png') center center no-repeat;
	background-size: 200px;
	width: 200px;
	height: 50px;

	&.black {
		background: url('~/assets/images/logo-dedurgerdam-black-medium.png') center center no-repeat;
		background-size: 200px;
	}
}

a {
	color: $footer-link-color;
	text-decoration: none;

	&:hover {
		color: $primary-color;
	}
}

@media (max-width: 1180px) {
	footer {
		.row {
			flex-flow: row wrap;

			.columns {
				margin: 20px 0;
			}
		}
	}
}

@media (max-width: 900px) {
	footer {
		padding: 50px 0;
		margin-top: 0;

		.socials {
			justify-content: center;
		}

		.row {
			.columns {
				width: 100%;
				margin: 25px auto;
				text-align: center;

				.footer-logo {
					margin: 0 auto;
				}
			}
		}

		&.bottom-footer {
			padding: 15px 0;
			flex-flow: column wrap;

			.row {
				flex-flow: column wrap;

				.columns {
					width: 100%;
					text-align: center !important;
					margin: 15px auto;
				}
			}
		}
	}
}

@media (max-width: 580px) {
	.partner-logos {
		a {
			margin: 10px 25px 40px;
		}
	}
}
</style>
